<!-- 会籍合同管理 -->
<template>
    <el-card class="fitness-index member-contract">
        <el-table
            border
            ref="tableData"
            v-if="tableData"
            :data="tableData"
            class="my-4"
            v-loading="loading"
            @row-click="clickRow"
            @selection-change="handleSelectChange"
        >
            <el-table-column type="selection" width="30px"></el-table-column>
            <el-table-column prop="id" :label="$t('Contract.id')" align="center" width="60px" v-if="false"/>
            <el-table-column prop="contractNum" :label="$t('Contract.number')" align="center">
                <template slot-scope="{$index, row}">
                    {{ row.contractNum }}
                </template>
            </el-table-column>
            <el-table-column prop="cardNum" :label="$t('Contract.card_hao')" align="center"/>
            <el-table-column prop="clientName" :label="$t('Member.name2')" align="center">
                <template slot-scope="{row}">
                    <span @click="handleUser(row.clientId)" class="task-workers">{{ row.clientName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="clientPhone" :label="$t('Common.telephone_number')" align="center" width="110px"/>
            <el-table-column prop="cardName" :label="$t('Contract.card_name')" align="center" />
            <el-table-column prop="creditStr" :label="$t('Contract.Desc.amount')" align="center" width="50px"/>
            <el-table-column prop="type" :label="$t('Contract.type')" align="center" />
            <el-table-column :label="$t('Contract.Desc.old_number')" align="center">
                <template slot-scope="{row}">
                    <span
                        @click="goDetails(row.originalContractNum)"
                        class="task-workers">
                        {{ row.originalContractNum }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="status" :label="$t('Contract.status')" align="center">
                <template slot-scope="{row}">
                    <span :class="row.status==='有效' ? 'task-status' : 'del-status'">{{ row.status }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="payableAmt" :label="$t('Charge.amount_receivable')" align="center" />
            <el-table-column prop="paidAmt" :label="$t('Sell.Charge.paid_amount')" align="center"/>
            <el-table-column prop="oweAmt" :label="$t('Sell.OutstandingAmount')" align="center"/>
            <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" align="center" width="100px"/>
            <el-table-column prop="activeCardWay" :label="$t('Member.open_card_method')" align="center"/>
            <el-table-column prop="validity" :label="$t('Contract.validity_period')" align="center" width="100px">
                <template slot-scope="{row}">
                    {{row.validity}}
                    <template v-if="row.frozen">
                        <el-tooltip class="item" effect="dark" placement="bottom">
                            <div slot="content" >
                                <div>{{ $t('Sell.freeze_date') }}</div>
                                <div>{{row.frozenDuration}}</div>
                            </div>
                            <span
                                class="iconfont icon-fitness-point diff-icon"
                                style="background-color: #db093f !important">
                            </span>
                        </el-tooltip>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')" align="center" width="100px" >
                <template slot-scope="{row}">
                    {{ row.contractSalesStaffNickname }}
                    <template v-if="row.contractSalesStaffNickname!==row.clientMshpSalesNickname">
                        <el-tooltip class="item" effect="dark" placement="bottom">
                            <div slot="content" >
                                <div>{{ $t('Sell.Unlike_followup_sales') }}</div>
                                <div>{{ $t('Other.Upload.followup_sales') }}：{{row.clientMshpSalesNickname}}</div>
                            </div>
                            <span class="iconfont icon-fitness-point diff-icon"></span>
                        </el-tooltip>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="clientMshpSalesNickname" :label="$t('Common.saler')" v-if="false"/>
            <el-table-column prop="recommendClientName" :label="$t('Client.Add.referrer')" align="center"/>
            <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')" align="center"/>
            <el-table-column prop="frozen" :label="$t('Sell.frozen_or_not')" v-if="false"/>
            <el-table-column prop="frozenDuration" :label="$t('Sell.freeze_date')" v-if="false"/>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-right mt-5"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>

        <!-- 批量修改支持门店弹窗 -->
        <el-dialog class="member-contract-dialog" :title="supportStore ? '批量修改支持门店' : '赠送'" :visible.sync="visible">
            <el-form
                ref="supportStores"
                :model="supportForm"
                :status-icon="true"
                :label-width="supportStore ? '120px' : '80px'"
                label-suffix=" : "
                label-position="right"
                v-loading="form_loading">
                <el-form-item :label="$t('Choose.choose')" >
                    <el-radio
                        v-model="supportForm.option"
                        :label="1">{{ $t('Sell.Dialog.choosed_contract') }}{{ contracts.length }}{{ $t('Choose.one') }}
                    </el-radio>
                    <el-radio
                        v-model="supportForm.option"
                        :label="2">{{ $t('Sell.Dialog.filter_total') }}{{ pagination.total }}{{ $t('Charge.count') }}
                    </el-radio>
                </el-form-item>
                <div v-if="supportStore" >
                    <el-form-item :label="$t('Reception.First.support_store')" prop="storeIds" v-if="supportStore">
                        <el-checkbox
                            :indeterminate="isIndeterminate"
                            v-model="checkAll"
                            @change="checkAllStore">{{ $t('Course.check_all') }}
                        </el-checkbox>
                        <div class="box-a">
                            <el-checkbox-group v-model="supportForm.storeIds" @change="handleStoreChange">
                                <el-checkbox
                                    style="margin: 0px 5px;width:100%;"
                                    v-for="item in stores"
                                    :label="item.id"
                                    :key="item.id">{{ item.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-form-item>
                </div>
                <template v-if="!supportStore">
                    <el-form-item :label="$t('Sell.gift')">
                        <el-checkbox >
                            {{ $t('Reception.Second.day_num') }}
                            <el-input class="mr-2 ml-2" v-model="supportForm.daysGiven" />
                            {{ $t('Week.day2') }}
                        </el-checkbox>
                        <div class="mt-2">
                            <el-checkbox>
                                {{ $t('Lesson.frequency') }}
                                <el-input class="mr-2 ml-2" v-model="supportForm.countsGiven" />
                                {{ $t('Week.ci') }}
                            </el-checkbox>
                        </div>
                    </el-form-item>
                </template>
                <el-form-item :label="$t('Common.remark')" prop="remark">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 10 }"
                        v-model="supportForm.remark"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button type="primary" slot="footer" @click="submit">{{ $t('Message.confirm') }}</el-button>
            </div>
        </el-dialog>
        <pay-form
            ref="pay"
            :contract="'member'"
            v-model="input"
            @fetchData="fetchData" />
        <!-- 修改合同开始时间 -->
        <modify-batch-time
            :total="pagination.total"
            :activeName="activeName"
            :filter="form"
            :contracts="contracts"
            :tableData="tableData"
            @fetchData="fetchData"
            :date="date"
            ref="batch" />
    </el-card>
</template>

<script>
import { Dialog, DatePicker, Row, Radio, Col } from 'element-ui';
import ModifyBatchTime from '@/components/Dialog/Sell/ModifyBatchTime.vue';
import PayForm from '@/components/Dialog/Client/PayForm';
import handleUser from '@/mixins/handleUser.js';

export default {
    props: ['activeName', 'id', 'form', 'date', 'stores'],
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRow: Row,
        ElRadio: Radio,
        ElCol: Col,
        PayForm,
        ModifyBatchTime,
    },
    mixins: [handleUser],
    data() {
        return {
            input: '',
            supportStore: false,
            loading: false,
            visible: false,
            form_loading: false,
            isIndeterminate: false,
            checkAll: false,
            supportForm: {
                contractNums: null,
                storeIds: [],
                daysGiven: null, // 赠送天数
                countsGiven: null, // 赠送次数
                remark: null,
                option: 1,
                filter: {},
            },
            tableData: [],
            contracts: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
        };
    },
    computed: {},
    mounted() {},
    watch: {
        activeName(val) {
            if (val === 'member') this.fetchData();
        },
        input(val) {
            if (val === 'update') this.flush();
        },
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        resetForm() {
            this.supportForm = {
                contractNums: null,
                storeIds: [],
                daysGiven: null, // 赠送天数
                countsGiven: null, // 赠送次数
                remark: null,
                option: 1,
                filter: {},
            };
        },
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            if (this.date) {
                this.form.createdAtStart = this.date[0];
                this.form.createdAtEnd = this.date[1];
            }
            API.get('contract/mshp/pages', {
                params: {
                    ...this.form,
                    ...this.pagination,
                },
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}个合同`;
                this.$emit('input', msg);
            }).finally(() => {
                this.loading = false;
            });
        },
        flush(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('contract/mshp/pages', {
                params: {
                    ...this.pagination,
                    statusCode: 1,
                },
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}个合同`;
                this.$emit('input', msg);
            }).finally(() => {
                this.loading = false;
            });
        },
        say(data) {
            this.form = data;
            this.fetchData();
        },
        handleSelectChange(val) {
            const data = val;
            this.contracts = val;
            this.$emit('headListen', data);
        },
        handleShow(row) {
            this.$router.push({
                name: 'Sell.Show',
                params: {
                    id: row.contractNum,
                    url: 'contract/mshp',
                },
            });
        },
        checkAllStore(val) {
            this.supportForm.storeIds = val ? this.stores.map(el => el.id) : [];
            this.isIndeterminate = false;
        },
        supportStores(data) {
            // supportStore ? '批量修改支持门店' : '赠送
            this.supportStore = data;
            if (this.contracts.length < 1) $ele.$message.warning(this.$t('Message.Please_select_a_data'));
            else if ((!this.supportStore && this.$$filterPermission('售卖-合同管理-赠送'))
            || (this.supportStore && '售卖-合同管理-批量修改合同开始时间')) {
                this.visible = true;
            } else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        handleStoreChange(val) {
            const checkedCount = val.length;
            this.checkAll = checkedCount === this.stores.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
        },
        submit() {
            if (this.supportForm.option === 1) this.supportForm.contractNums = this.contracts.map(el => el.contractNum);
            else this.supportForm.contractNums = this.tableData.map(el => el.contractNum);

            this.supportForm.filter = this.form;
            if (this.date) {
                this.supportForm.filter.createdAtStart = this.date[0];
                this.supportForm.filter.createdAtEnd = this.date[1];
            }

            if (this.supportStore) this.postSupportStore();
            else this.postGift();
        },
        postGift() {
            const form = Object.assign({}, this.supportForm);
            delete form.storeIds;
            API.post(`contract/mshp/give`, this.supportForm).then(() => {
                $ele.$message.success(this.$t('Message.GiftSuccess'));
                this.visible = false;
                this.fetchData();
            });
        },
        postSupportStore() {
            const form = Object.assign({}, this.supportForm);
            delete form.daysGiven;
            delete form.countsGiven;
            API.post('contract/mshp/support-store', form)
            .then(() => {
                $ele.$message.success(this.$t('Message.Successful_revision'));
                this.visible = false;
                this.fetchData();
            })
            .finally(() => {
                this.loading = false;
                this.isIndeterminate = false;
            });
        },
        validSelect() {
            if (this.contracts.length > 1) $ele.$message.warning(this.$t('Message.once_data'));
            else if (this.contracts.length < 1) $ele.$message.warning(this.$t('Message.Please_select_a_data'));
            else return true;
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        pay() {
            if (this.validSelect()) this.$refs.pay.open(this.contracts[0].contractNum);
        },
        openBatch() {
            this.$refs.batch.open(this.contracts);
        },
        goDetails(val) {
            let form = this.form;
            form.contractNum = val;
            this.$emit('update:form', form);
            this.fetchData();
        },
    },
    created() {
        if (this.activeName === 'member') this.fetchData();
    },
};
</script>
<style lang="scss">
.member-contract {
    .icon {
        position: absolute !important;
        right: 0px;
        display: inline;
    }
    .title-3a {
        height: 20px;
        color: grey;
        line-height: 10px;
        font-size: 12px;
        font-weight: 400;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .box-a {
        padding: 10px 15px;
        background: #fff!important;
        max-height: 130px!important;
        overflow: scroll;
        border: 1px solid #e6e6e6;
    }
    .task-workers {
        color: #409EFF;
        cursor: pointer;
    }
    .task-status {
        color: #2a9546;
    }
    a:hover {
        color: #409EFF;
    }
    .del-status {
        color:#ce6969;
    }
    .diff-icon{
        background-color: orange !important;
        border-radius:25px;
        color:white;
    }
    .member-contract-dialog {
        .el-dialog {
            width: 710px;
        }
    }
}
</style>
